import { WebFormQuestionTypeTableFieldFragment$key } from "@/web-form/table/__generated__/WebFormQuestionTypeTableFieldFragment.graphql"
import { useWebFormQuestionTypes } from "@/web-form/utils/useWebFormQuestionTypes"
import { graphql, useFragment } from "react-relay"

interface Props {
  webFormQuestionKey: WebFormQuestionTypeTableFieldFragment$key
}

function WebFormQuestionTypeTableField({ webFormQuestionKey }: Props) {
  const webFormQuestion = useFragment<WebFormQuestionTypeTableFieldFragment$key>(
    graphql`
      fragment WebFormQuestionTypeTableFieldFragment on WebFormQuestion {
        type
        richEditorBody
        options {
          id
          label
        }
      }
    `,
    webFormQuestionKey
  )

  const questionTypes = useWebFormQuestionTypes()
  const typeIcon = questionTypes.find((qt) => qt.value === webFormQuestion.type)?.icon

  return <span>{typeIcon}</span>
}

export default WebFormQuestionTypeTableField
